export default "__VITE_ASSET__BEwx77yV__"